module.exports = __webpack_public_path__ + "static/img/button_consume@2x.91391bf0.png";